import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import LegalModal from '../../components/LegalModal';
import { getLegalContent } from '../../services/legalService';
import { COMPANY_NAME, COMPANY_LOCATION, SUPPORT_EMAIL } from '../../config/region';

const linkClass =
  'text-xs sm:text-sm text-slate-400 hover:text-cyan-300 transition-colors focus:outline-none focus:ring-2 focus:ring-cyan-500 focus:ring-offset-2 focus:ring-offset-slate-900 rounded';

const LandingFooter: React.FC = () => {
  const [legalModal, setLegalModal] = useState<'terms' | 'privacy' | null>(null);
  const [termsMarkdown, setTermsMarkdown] = useState('');
  const [privacyMarkdown, setPrivacyMarkdown] = useState('');

  useEffect(() => {
    getLegalContent().then((content) => {
      setTermsMarkdown(content.terms_markdown ?? '');
      setPrivacyMarkdown(content.privacy_markdown ?? '');
    });
  }, []);

  return (
    <>
      <footer className="bg-slate-950 border-t border-white/5 py-8 sm:py-10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-7 sm:gap-8">
            <div>
              <h4 className="text-sm font-semibold text-white mb-3">Product</h4>
              <nav className="flex flex-col gap-2" aria-label="Product links">
                <a href="#features" className={linkClass}>Features</a>
                <a href="#how-it-works" className={linkClass}>How It Works</a>
                <a href="#value" className={linkClass}>Why choose us?</a>
                <a href="#pricing" className={linkClass}>Pricing</a>
                <a href="#faq" className={linkClass}>FAQ</a>
              </nav>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-white mb-3">Legal</h4>
              <div className="flex flex-col gap-2">
                <button
                  type="button"
                  onClick={() => setLegalModal('terms')}
                  className={`${linkClass} text-left`}
                >
                  Terms of Service
                </button>
                <button
                  type="button"
                  onClick={() => setLegalModal('privacy')}
                  className={`${linkClass} text-left`}
                >
                  Privacy Policy
                </button>
              </div>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-white mb-3">Support</h4>
              <div className="flex flex-col gap-2">
                <a href={`mailto:${SUPPORT_EMAIL}`} className={linkClass}>
                  {SUPPORT_EMAIL}
                </a>
                <Link to="/login" className={linkClass}>
                  Support portal
                </Link>
              </div>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-white mb-3">Company</h4>
              <p className="text-xs sm:text-sm text-slate-400">
                {COMPANY_LOCATION ? `${COMPANY_NAME}, ${COMPANY_LOCATION}` : COMPANY_NAME}
              </p>
            </div>
          </div>

          <div className="mt-8 pt-5 border-t border-white/10">
            <p className="text-xs sm:text-sm text-slate-500 text-center sm:text-left">
              © {new Date().getFullYear()} {COMPANY_NAME.replace(/\.$/, '')}. All rights reserved.
            </p>
          </div>
        </div>
      </footer>

      <LegalModal
        open={legalModal === 'terms'}
        onClose={() => setLegalModal(null)}
        title="Terms of Service"
        markdown={termsMarkdown}
      />
      <LegalModal
        open={legalModal === 'privacy'}
        onClose={() => setLegalModal(null)}
        title="Privacy Policy"
        markdown={privacyMarkdown}
      />
    </>
  );
};

export default LandingFooter;
